import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';
import WalletConnectModal from './WalletConnectModal';
import WalletModal from './WalletModal';
import codeImage from '../assets/code.png';
import sewing_machine from '../assets/sewing-machine.png';
import auction from '../assets/auction.png';
import documentIcon from '../assets/document.png';
import twitter from '../assets/twitter.png';
import discord from '../assets/discord.png';
import instagram from '../assets/instagram.png';
import settings2 from '../assets/settings2.png';
import padlockIcon from '../assets/padlock.png';
import group83Icon from '../assets/Group83.png';
import ellipseIcon from '../assets/ellipse.png';
import logoutIcon from '../assets/logout.png';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isWalletConnectModalOpen, setIsWalletConnectModalOpen] = useState(false);
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const userMenuRef = useRef(null);
  const menuRef = useRef(null);

  const getEmailPrefix = (email) => {
    if (!email) return '';
    return email.substring(0, 5);
  };

  // Закрытие меню пользователя при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };

    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);

  // Закрытие меню с тремя квадратиками при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
      <header
        className="bg-[#131313] border-b-4 border-[#830C0C] flex items-center justify-between relative flex-shrink-0"
        style={{
          width: '100vw',
          height: 'clamp(60px, 3.59vw, 69px)',
          zIndex: 30
        }}
      >
        {/* Логотип слева */}
        <div className="flex-shrink-0">
          <img
            src={codeImage}
            alt="Logo"
            style={{ width: 'clamp(200px, 12.5vw, 240px)', height: 'clamp(60px, 3.59vw, 69px)' }}
          />
        </div>

        {/* Центральная часть — гибкая */}
        <div
          className="flex items-center justify-end gap-[1.5vw]"
          style={{
            width: 'calc(100vw - clamp(200px, 12.5vw, 240px))',
            paddingRight: '2vw'
          }}
        >
          {isAuthenticated ? (
            <>
              {/* Wallet кнопка */}
              <button
                onClick={() => setIsWalletConnectModalOpen(true)}
                className="bg-[#5A9FFF] text-white rounded-[4px] hover:opacity-80 transition-opacity flex items-center justify-center"
                style={{
                  width: 'clamp(70px, 4.69vw, 90px)',
                  height: 'clamp(24px, 1.56vw, 30px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.73vw, 14px)',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                Wallet
              </button>

              {/* Первая разделительная линия */}
              <div
                className="bg-[#D9D9D9]"
                style={{ 
                  width: 'clamp(0.5px, 0.05vw, 1px)', 
                  height: 'clamp(36px, 2.34vw, 45px)',
                  opacity: 0.3
                }}
              />

              {/* Кнопка с ником и аватаркой */}
              <div className="relative" ref={userMenuRef}>
                <button
                  onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                  className="flex items-center rounded-[4px] hover:opacity-80 transition-opacity cursor-pointer relative"
                  style={{
                    minWidth: 'clamp(88px, 5.78vw, 111px)',
                    width: 'auto',
                    height: 'clamp(24px, 1.56vw, 30px)',
                    backgroundColor: 'transparent',
                    border: '1px solid rgba(255, 0, 0, 0.4)',
                    padding: 0,
                    gap: 'clamp(4px, 0.26vw, 5px)'
                  }}
                >
                  {/* Секция с ником */}
                  <div
                    className="flex items-center justify-center h-full flex-grow"
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(11px, 0.73vw, 14px)',
                      color: '#FFFFFF',
                      paddingLeft: 'clamp(4px, 0.26vw, 5px)',
                      paddingRight: 'clamp(2px, 0.13vw, 2px)',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    @{user?.nickname || getEmailPrefix(user?.email) || 'User'}
                  </div>

                  {/* Секция с аватаркой */}
                  <div
                    className="flex items-center justify-center flex-shrink-0"
                    style={{
                      width: 'clamp(34px, 2.24vw, 43px)',
                      height: '100%',
                      backgroundColor: '#8F0A0A',
                      borderRadius: '3px'
                    }}
                  >
                    {user?.avatar ? (
                      <img
                        src={user.avatar}
                        alt="Avatar"
                        style={{
                          width: 'clamp(19px, 1.25vw, 24px)',
                          height: 'clamp(19px, 1.25vw, 24px)',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <img
                        src={ellipseIcon}
                        alt="Default Avatar"
                        style={{
                          width: 'clamp(19px, 1.25vw, 24px)',
                          height: 'clamp(19px, 1.25vw, 24px)',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    )}
                  </div>
                </button>

                {/* Выпадающее меню пользователя */}
                {isUserMenuOpen && (
                  <div
                    className="absolute overflow-hidden z-50"
                    style={{
                      right: 0,
                      top: 'calc(100% + 8px)',
                      width: '210px',
                      height: '165px',
                      backgroundColor: '#1C1A1A',
                      borderRadius: '4px',
                      border: '1px solid rgba(255, 255, 255, 0.1)'
                    }}
                  >
                    {/* Верхняя секция с информацией о пользователе */}
                    <div
                      onClick={() => {
                        setIsUserMenuOpen(false);
                        navigate('/profile');
                      }}
                      className="cursor-pointer transition-colors"
                      style={{
                        padding: '16px',
                        position: 'relative',
                        display: 'flex',
                        gap: '12px',
                        alignItems: 'flex-start'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      {/* Бейдж Collector */}
                      <div
                        style={{
                          position: 'absolute',
                          top: '16px',
                          right: '16px',
                          width: '58px',
                          height: '16px',
                          backgroundColor: '#054238',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontFamily: 'Geologica, sans-serif',
                          fontWeight: 400,
                          fontSize: '8px',
                          color: 'rgba(255, 255, 255, 0.8)'
                        }}
                      >
                        Collector
                      </div>

                      {/* Аватарка */}
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          border: '1px solid rgba(255, 0, 0, 0.4)',
                          overflow: 'hidden',
                          flexShrink: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {user?.avatar ? (
                          <img
                            src={user.avatar}
                            alt="Avatar"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                          />
                        ) : (
                          <img
                            src={ellipseIcon}
                            alt="Default Avatar"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                          />
                        )}
                      </div>

                      {/* Текстовая информация справа от аватарки */}
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '4px',
                          paddingRight: '70px'
                        }}
                      >
                        {/* Имя пользователя */}
                        <div
                          style={{
                            fontFamily: 'Geologica, sans-serif',
                            fontWeight: 400,
                            fontSize: '12px',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          Hi, {user?.nickname || getEmailPrefix(user?.email) || 'User'}
                        </div>

                        {/* Email */}
                        <div
                          style={{
                            fontFamily: 'Geologica, sans-serif',
                            fontWeight: 400,
                            fontSize: '9px',
                            color: 'rgba(255, 255, 255, 0.6)'
                          }}
                        >
                          {user?.email || ''}
                        </div>
                      </div>
                    </div>

                    {/* Разделительная линия */}
                    <div
                      style={{
                        width: '130px',
                        height: '1px',
                        backgroundColor: 'rgba(217, 217, 217, 0.15)',
                        margin: '0 auto'
                      }}
                    />

                    {/* Кнопки Settings и Log out */}
                    <div style={{ marginTop: '8px' }}>
                      {/* Кнопка Settings */}
                      <div
                        onClick={() => {
                          setIsUserMenuOpen(false);
                          navigate('/settings');
                        }}
                        className="flex items-center gap-3 cursor-pointer transition-colors"
                        style={{
                          width: '210px',
                          height: '35px',
                          padding: '0 16px',
                          backgroundColor: '#1C1A1A',
                          fontFamily: 'Geologica, sans-serif',
                          fontWeight: 400,
                          fontSize: '14px',
                          color: 'rgba(255, 255, 255, 0.8)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#3D3B3B';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#1C1A1A';
                        }}
                      >
                        <img 
                          src={settings2} 
                          alt="Settings" 
                          style={{
                            width: '18px',
                            height: '18px'
                          }}
                        />
                        <span>Settings</span>
                      </div>

                      {/* Кнопка Log out */}
                      <div
                        onClick={() => {
                          setIsUserMenuOpen(false);
                          logout();
                          navigate('/');
                        }}
                        className="flex items-center gap-3 cursor-pointer transition-colors"
                        style={{
                          width: '210px',
                          height: '35px',
                          padding: '0 16px',
                          backgroundColor: '#1C1A1A',
                          fontFamily: 'Geologica, sans-serif',
                          fontWeight: 400,
                          fontSize: '14px',
                          color: 'rgba(255, 255, 255, 0.8)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#3D3B3B';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#1C1A1A';
                        }}
                      >
                        <img 
                          src={logoutIcon} 
                          alt="Log out" 
                          style={{
                            width: '18px',
                            height: '18px'
                          }}
                        />
                        <span>Log out</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Вторая разделительная линия */}
              <div
                className="bg-[#D9D9D9]"
                style={{ 
                  width: 'clamp(0.5px, 0.05vw, 1px)', 
                  height: 'clamp(36px, 2.34vw, 45px)',
                  opacity: 0.3
                }}
              />

              {/* Секция с цифрой и иконкой */}
              <div
                className="flex items-center rounded-[4px]"
                style={{
                  width: 'clamp(48px, 3.13vw, 60px)',
                  height: 'clamp(24px, 1.56vw, 30px)'
                }}
              >
                {/* Секция с цифрой */}
                <div
                  className="flex items-center justify-center rounded-l-[3px]"
                  style={{
                    width: 'clamp(24px, 1.56vw, 30px)',
                    height: '100%',
                    backgroundColor: 'transparent',
                    border: '1px solid #830C0C',
                    borderRight: 'none',
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(11px, 0.73vw, 14px)',
                    color: '#FFFFFF'
                  }}
                >
                  11
                </div>

                {/* Секция с иконкой */}
                <div
                  className="flex items-center justify-center rounded-r-[3px]"
                  style={{
                    width: 'clamp(24px, 1.56vw, 30px)',
                    height: '100%',
                    backgroundColor: '#8F0A0A'
                  }}
                >
                  <img
                    src={group83Icon}
                    alt="Icon"
                    style={{
                      width: 'clamp(14px, 0.94vw, 18px)',
                      height: 'clamp(14px, 0.94vw, 18px)'
                    }}
                    onError={(e) => {
                      // Если файл не найден, показываем placeholder
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <button
              onClick={() => setIsAuthModalOpen(true)}
              className="border border-[#356DFD] text-white rounded hover:opacity-80 transition-all flex items-center justify-center"
              style={{
                width: '5.78vw',
                height: '1.82vw',
                backgroundColor: 'rgba(53, 109, 253, 0.15)',
                fontFamily: 'Keania One',
                fontWeight: 400,
                fontSize: 'clamp(10px, 0.73vw, 14px)'
              }}
            >
              Sign In
            </button>
          )}

          {/* Три квадратика справа */}
          <div className="relative" ref={menuRef}>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="flex flex-col hover:opacity-80 transition-opacity items-center justify-center"
              style={{
                width: 'clamp(5px, 0.31vw, 6px)',
                height: 'clamp(25px, 1.61vw, 31px)',
                cursor: 'pointer',
                background: 'transparent',
                border: 'none',
                padding: 0,
                gap: 'clamp(4px, 0.41vw, 6.5px)'
              }}
            >
              <div 
                className="bg-[#848484] flex-shrink-0" 
                style={{ 
                  width: 'clamp(5px, 0.31vw, 6px)', 
                  height: 'clamp(5px, 0.31vw, 6px)' 
                }} 
              />
              <div 
                className="bg-[#848484] flex-shrink-0" 
                style={{ 
                  width: 'clamp(5px, 0.31vw, 6px)', 
                  height: 'clamp(5px, 0.31vw, 6px)' 
                }} 
              />
              <div 
                className="bg-[#848484] flex-shrink-0" 
                style={{ 
                  width: 'clamp(5px, 0.31vw, 6px)', 
                  height: 'clamp(5px, 0.31vw, 6px)' 
                }} 
              />
            </button>

            {isMenuOpen && (
              <div
                className="absolute overflow-hidden z-50"
                style={{
                  right: 0,
                  top: '2.6vw',
                  width: '210px',
                  height: '355px',
                  backgroundColor: '#1C1A1A',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '4px'
                }}
              >
                {[
                  { icon: sewing_machine, text: 'About' },
                  { icon: instagram, text: 'Instagram' },
                  { icon: discord, text: 'Discord' },
                  { icon: twitter, text: 'Twitter' },
                  { icon: settings2, text: 'Settings', path: '/settings' },
                  { icon: documentIcon, text: 'Term of Service' },
                  { icon: auction, text: 'Privacy Policy' },
                  ...(isAuthenticated ? [{ icon: padlockIcon, text: 'Log Out', action: 'logout' }] : [])
                ].map(({ icon, text, path, action }) => {
                  const showDividerAfterAbout = text === 'About';
                  const showDividerAfterSettings = text === 'Settings';
                  
                  return (
                    <React.Fragment key={text}>
                      <div
                        onClick={() => {
                          if (action === 'logout') {
                            setIsMenuOpen(false);
                            logout();
                            navigate('/');
                          } else if (path) {
                            setIsMenuOpen(false);
                            navigate(path);
                          }
                        }}
                        className="flex items-center gap-3 cursor-pointer transition-colors"
                        style={{
                          padding: '12px 16px',
                          fontFamily: 'Geologica, sans-serif',
                          fontWeight: 400,
                          fontSize: '14px',
                          color: 'rgba(255, 255, 255, 0.8)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                      >
                        <img 
                          src={icon} 
                          alt={text} 
                          style={{
                            width: '16px',
                            height: '16px'
                          }}
                        />
                        <span>{text}</span>
                      </div>
                      {showDividerAfterAbout && (
                        <div
                          style={{
                            width: '130px',
                            height: '1px',
                            backgroundColor: 'rgba(217, 217, 217, 0.15)',
                            margin: '8px auto'
                          }}
                        />
                      )}
                      {showDividerAfterSettings && (
                        <div
                          style={{
                            width: '130px',
                            height: '1px',
                            backgroundColor: 'rgba(217, 217, 217, 0.15)',
                            margin: '8px auto'
                          }}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </header>

      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => setIsAuthModalOpen(false)} 
      />

      <WalletConnectModal 
        isOpen={isWalletConnectModalOpen} 
        onClose={() => setIsWalletConnectModalOpen(false)}
        onBinanceClick={() => setIsWalletModalOpen(true)}
      />

      <WalletModal 
        isOpen={isWalletModalOpen} 
        onClose={() => setIsWalletModalOpen(false)} 
      />
    </>
  );
}

